import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProjectContext = createContext(null);
export const useProjects = () => useContext(ProjectContext);

export function ProjectProvider({ children }) {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("rawaj_active"));
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/projects");
      setProjects(data);
      const live = data.filter((p) => p.status !== "archived");
      if (!data.find((p) => p.id === activeId)) {
        const first = (live[0] || data[0])?.id;
        if (first) { setActiveId(first); localStorage.setItem("rawaj_active", first); }
      }
      if (!data.length) setActiveId(null);
      return data;
    } catch (e) {
      return [];
    } finally {
      setLoading(false);
    }
  }, [activeId]);

  useEffect(() => {
    if (user) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const selectProject = (id) => {
    setActiveId(id);
    localStorage.setItem("rawaj_active", id);
  };

  const activeProject = projects.find((p) => p.id === activeId) || null;
  const activeProjects = projects.filter((p) => p.status !== "archived");

  return (
    <ProjectContext.Provider
      value={{ projects, activeProjects, activeProject, activeId, selectProject, refresh, loading, setProjects }}
    >
      {children}
    </ProjectContext.Provider>
  );
}
